/* RESPONSIBLE TEAM: team-knowledge-foundations */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import ConversationAttributeDescriptor from 'embercom/models/conversation-attributes/descriptor';
import type AiContentSegmentsService from 'embercom/services/ai-content-segments-service';
import type ContentImportService from 'embercom/services/content-import-service';
import type Store from '@ember-data/store';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class AudienceRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare aiContentSegmentsService: AiContentSegmentsService;
  @service declare contentImportService: ContentImportService;
  @service declare finStandaloneService: FinStandaloneService;
  @service declare store: Store;

  async beforeModel() {
    let promises = [
      ConversationAttributeDescriptor.peekAllAndMaybeLoad(),
      this.store.findRecord('messenger-settings/look-and-feel', this.appService.app.id),
      this.aiContentSegmentsService.loadSegments(),
      this.contentImportService.fetchContentImportSources(),
    ];

    if (this.appService.app.canUseStandalone) {
      promises.push(this.finStandaloneService.platform.loadDataFields());
    }

    await Promise.all(promises);
  }

  get titleToken() {
    return this.intl.t('new-settings.submenu.data.audiences');
  }
}
